import { render, staticRenderFns } from "./sendAddressInfo.vue?vue&type=template&id=8e0856aa&scoped=true&"
import script from "./sendAddressInfo.vue?vue&type=script&lang=js&"
export * from "./sendAddressInfo.vue?vue&type=script&lang=js&"
import style0 from "./sendAddressInfo.vue?vue&type=style&index=0&id=8e0856aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e0856aa",
  null
  
)

export default component.exports